<template>
    <div>
        <v-card elevation="6" class="base-card-container pa-0 mt-4">
            <v-card-title class="card-title-style"> Autorizar Desconclusion</v-card-title>

            <v-card-text>
                <v-row justify="center" v-if="loaded == false">
                    <v-col cols="12" md="7">
                        <v-skeleton-loader
                            type="list-item-avatar, divider, list-item-three-line, card-heading, image, actions"></v-skeleton-loader>
                    </v-col>
                </v-row>
                <v-row justify="center" v-if="loaded == true">
                    <v-col cols="12" md="7">
                        <div>
                            <span class="type-label-style">Tipo de Movimiento</span>
                            <p class="type-text-style">Autorizar desconclusion</p>
                        </div>


                        <template v-if="fechas.svfhcerrado != null">
                            <v-divider class="mt-1"></v-divider>
                            <div>
                                <span class="type-label-style">¿Se autoriza la Desconclusion? </span>

                                <v-container>

                                    <v-radio-group v-model="radioAut" row>
                                        <v-radio label="SI" value="S"></v-radio>
                                        <v-radio label="NO" value="N"></v-radio>
                                    </v-radio-group>

                                </v-container>

                            </div>

                            <span style="color: red;" v-show="validaRadioAut">Selección requerida</span>
                        </template>



                        <template
                            v-if="(radioAut == 'S' && fechas.svfhconclusion != null) || (fechas.svfhcerrado == null && fechas.svfhconclusion != null)">

                            <v-divider class="mt-1"></v-divider>


                            <div>
                                <span class="type-label-style">¿Desea eliminar la conclusión administrativa?</span>



                                <v-container>

                                    <v-radio-group v-model="radioElim" row>
                                        <v-radio label="SI" value="S"></v-radio>
                                        <v-radio label="NO" value="N"></v-radio>
                                    </v-radio-group>

                                </v-container>

                            </div>

                            <span style="color: red;" v-show="validaRadioElim">Selección requerida</span>
                        </template>


                        <v-divider class="mt-1"></v-divider>

                        <div>
                            <span class="type-label-style">Firma Electrónica:</span>

                            <br />

                            <v-text-field v-model="firma" outlined dense autocomplete="off" required ref="input"
                                autofocus maxlength="17" v-on:keydown.enter.prevent=''
                                style="-webkit-text-security: disc;">
                            </v-text-field>
                            <span style="color: red;" v-show="validafirma">{{ texto }}</span>

                        </div>

                        <v-divider class="mt-1"></v-divider>

                        <div class="mt-4">
                            <span class="type-label-style">Observaciones solicitud de Desconclusion</span>
                            <v-textarea v-model="obssolicitud"
                                v-on:blur="obssolicitud = obssolicitud != null ? obssolicitud.trim() : null"
                                class="mt-2" background-color="grey lighten-2" outlined disabled></v-textarea>
                        </div>

                        <v-divider class="mt-1"></v-divider>

                        <v-form ref="form" v-model="validForm" lazy-validation>

                            <div class="mt-4">
                                <span class="type-label-style">Observaciones de Autorizar Desconclusion</span>
                                <v-textarea id="textareaobs"
                                    v-on:blur="observacionesSelected = observacionesSelected != null ? observacionesSelected.trim() : null"
                                    v-model="observacionesSelected" class="mt-2"
                                    :counter="$store.state.maxLengthComentarios" outlined
                                    :maxlength="$store.state.maxLengthComentarios" :rules="rulestextarea"></v-textarea>
                            </div>
                        </v-form>
                    </v-col>
                </v-row>
                <v-row justify="center">
                    <v-card-actions>
                        <v-spacer></v-spacer>

                        <v-btn class="ma-2" color="primary" title="Guardar" @click="saveMovimientoProcess()"
                            :disabled="disBtn">
                            <span style='color: white;'>Guardar</span>
                        </v-btn>

                        <v-btn color="#FF4081" v-on:click="clearOptions()">
                            <span style='color: white;'>Limpiar</span>
                        </v-btn>


                        <v-spacer></v-spacer>
                    </v-card-actions>
                </v-row>
            </v-card-text>

        </v-card>
    </div>
</template>

<script>

import { mapActions, mapMutations, mapState, mapGetters } from "vuex";
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
import desconclusion from '@/services/Desconclusion/desconclusion.service.js';
import moment from "moment";
import Reporte from "@/services/RLV/RLV.service.js";

export default {
    data() {
        return {
            validForm: true,

            loaded: false,
            motivoSelected: "",


            rulestextarea: [
                (v) => !!v || "Campo requerido",
                (v) => {
                    if (v == null) {
                        return true;
                    } else {
                        if (v.trim().length < 12) {
                            return "Mínimo 12 Carácteres";
                        } else if (v.trim().length > this.$store.state.maxLengthComentarios) {
                            return "Máximo " + this.$store.state.maxLengthComentarios + " Carácteres";
                        } else return true;
                    }
                },
            ],

            ruleSelect: [(v) => !!v || "Campo requerido"],

            observacionesSelected: "",

            aiclave: 0,

            //Autorizar Conclusion
            validafirma: false,
            texto: '',
            obssolicitud: "",
            firma: '',
            fechas: null,
            radioAut: "",
            radioElim: "",
            validaRadioAut: false,
            validaRadioElim: false,
            disBtn: false,
            datos: {},
            asistenciaurl: ''

        };
    },
    computed: {
        ...mapState({ drawer: (state) => state.drawer }),
        ...mapState(["domain", "informationPage", "permission"]),
        ...mapGetters(["getUser", "THEME_STATE"]),

        DRAWER_STATE: {
            get() {
                return this.drawer;
            },
        },
    },
    async mounted() {
        this.changeReporteMenuOption('NoView');
        this.dateCollabsable = true;
        this.datos = await MetodosGenerales.obtenerSessionReporte('reporte');
        this.aiclave = this.datos.aiclave;
        let encabezado = await desconclusion.DatosDesconclusion(this, this.datos);
        var lduslogin = encabezado.lduslogin;
        var horasTranscurridas = parseInt(encabezado.horasTranscurridas);
        var svpuedeconcluir = parseInt(encabezado.svpuedeconcluir);
        var uslogin = this.getUser.get(this.permission.global).uslogin;
        var permisoLider = false;
        var autorizaDesconclu = false;
        this.asistenciaurl = await MetodosGenerales.ObtenerURL(this.datos);

        //Permiso Lider
        await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '49').then(response => {
            if (response.data.length > 0) {
                permisoLider = true;
            }
        });

        var dataDesc = await desconclusion.VerificarDesconclusion(this, this.datos);
        let desconclusionInt = parseInt(dataDesc);

        if (desconclusionInt == 0) {
            this.$router.push({ name: `NoAutorizado` }).catch(error => error);
        }
        if (this.aiclave == 1) {
            await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '92').then(response => {
                if (response.data.length > 0) {
                    autorizaDesconclu = true;
                } else {
                    this.$router.push({ name: `NoAutorizado` }).catch(error => error);
                }
            });
        }
        else if (this.aiclave == 5) {
            await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '166').then(response => {
                if (response.data.length > 0) {
                    autorizaDesconclu = true;
                } else {
                    this.$router.push({ name: `NoAutorizado` }).catch(error => error);
                }

            });
        }
        else if (this.aiclave == 23) {
            await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '162').then(response => {
                if (response.data.length > 0) {
                    autorizaDesconclu = true;
                } else {
                    this.$router.push({ name: `NoAutorizado` }).catch(error => error);
                }
            });
        }
        else if (this.aiclave == 24) {
            await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '164').then(response => {
                if (response.data.length > 0) {
                    autorizaDesconclu = true;
                } else {
                    this.$router.push({ name: `NoAutorizado` }).catch(error => error);
                }
            });
        }
        else if (this.aiclave == 27) {
            await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '371').then(response => {
                if (response.data.length > 0) {
                    autorizaDesconclu = true;
                } else {
                    this.$router.push({ name: `NoAutorizado` }).catch(error => error);
                }
            });
        }
        if (this.aiclave == 5) {
            if (svpuedeconcluir == 0 && autorizaDesconclu == true) {
            }
            else {
                this.$router.push({ name: `NoAutorizado` }).catch(error => error);
            }
        }
        else {
            if (lduslogin == uslogin && horasTranscurridas < 96 && permisoLider == true || svpuedeconcluir == 0 && autorizaDesconclu == true) {
            } else {
                this.$router.push({ name: `NoAutorizado` }).catch(error => error);
            }
        }

        this.obssolicitud = await desconclusion.ObsSolicitudDesc(this, this.datos);
        let data = await desconclusion.fechasReporte(this, this.datos);
        this.fechas = data[0];
        this.loaded = true;

    },
    methods: {
        ...mapMutations(["changeReporteMenuOption"]),
        clearOptions() {
            this.$refs.form.reset();
            this.observacionesSelected = ""
            this.motivoSelected = "";
            this.radioAut = "";
            this.radioElim = "";
            //Limpiar Alertas
            this.texto = '';
            this.firma = '';
            this.validafirma = false;
            this.validaRadioElim = false;
            this.validaRadioAut = false;
            this.formValidation = true;

            let today = new Date().toJSON().slice(0, 10);
            this.selectedDate = today;
        },
        async saveMovimientoProcess() {
            this.disBtn = true;
            let formValidation = this.$refs.form.validate();
            if (this.firma == '') {
                this.texto = 'Campo requerido';
                this.validafirma = true;
            }
            else if (this.firma.length < 8 /*|| this.firma.length > 16*/) {
                this.validafirma = true;
                this.texto = 'El número de caracteres debe ser un mínimo de 8';
            }
            if ((this.radioAut == 'S' && this.radioElim == "") || (this.fechas.svfhcerrado == null && this.radioElim == "")) {
                formValidation = false;
                this.validaRadioElim = true;
            }
            else if (this.radioAut == "" && this.fechas.svfhcerrado != null) {
                formValidation = false;
                this.validaRadioAut = true;
            }
            if (!formValidation || this.validafirma) {
                this.disBtn = false;
                return;
            }
            let firmaResp = await desconclusion.ValidarEFirma(this, this.firma);
            if (firmaResp.length != 1) {
                this.validafirma = true;
                this.texto = 'Su firma electrónica es incorrecta';
                this.disBtn = false;
                return;
            }
            else {
                this.$swal({
                    position: "center",
                    title: "Cargando...",
                    html: "Espere un momento por favor",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    confirm: false,
                });
                this.$swal.showLoading();
            }
            try {
                let fechaCerrado = false;
                let fechaConclusion = false;
                if (this.fechas.svfhcerrado != null) {
                    fechaCerrado = true;
                }
                if (this.fechas.svfhconclusion != null) {
                    fechaConclusion = true;
                }
                let resp = await desconclusion.AutorizarDesconclusion(this, this.radioAut, this.radioElim, this.firma, this.observacionesSelected, fechaCerrado, fechaConclusion, this.datos, this.fechas.svfhconclusion
                );
                if (resp = "Correcta") {
                    this.$swal({
                        position: "center",
                        icon: "success",
                        title: "Exito!",
                        html: "Movimiento realizado correctamente",
                        allowOutsideClick: false,
                        showConfirmButton: true,
                        timer: 3000,
                    }).then(() => {
                        this.$emit('ReloadEncabezado');
                        this.$router.push({ path: this.asistenciaurl + '/ReporteDetalle' });
                    });
                }
                else {
                    this.$swal({
                        position: "center",
                        icon: "error",
                        title: "Algo salio mal",
                        html: "Algo salio mal, por favor intente de nuevo mas tarde",
                        showConfirmButton: true,
                    });
                }
            } catch (e) {
                this.$swal({
                    position: "center",
                    icon: "error",
                    title: "Algo salio mal",
                    html: "Algo salio mal, por favor intente de nuevo mas tarde",
                    showConfirmButton: true,
                });
            }
        },
    },
    watch: {
        'firma': function () {
            if (this.firma != '')
                this.validafirma = false;
        },
        'radioAut': function () {
            if (this.radioAut != "") {
                this.validaRadioAut = false;
            }

            if (this.radioAut == 'N') {
                this.radioElim = null;
            }
        },
        'radioElim': function () {
            if (this.radioElim != "")
                this.validaRadioElim = false;
        }
    },
};
</script>

<style>
.lockBtn {
    font-size: 40px !important;
}

.obsDis {
    background-color: lightgray !important;
}

.addMovimientoClassList .vs-collapse-item--header {
    padding-top: 6px !important;
    padding-bottom: 6px !important;
    background-color: #e0e0e0 !important;
}

.addMovimientoClassList .con-content--item {
    padding: 0px !important;
}
</style>

<style scoped>
.card-title-style {
    background-color: #536dfe;
    font-family: "Poppins", sans-serif;
    font-weight: 600;
    font-size: 1.1em;
    color: white;
}

.title-card-style {
    padding: 1.5px !important;
    max-height: auto;
}

.collapsable-container {
    background-color: white;
    height: 100% !important;
}

.type-label-style {
    font-family: "Roboto", sans-serif;
    font-weight: 400;
    font-size: 12px;
}

.type-text-style {
    font-family: "Poppins", sans-serif;
    font-weight: 700;
    font-size: 1.3em;
}

.date-card-title-text {
    margin-top: 1px !important;
    margin-bottom: 1px !important;
    font-family: "Roboto", sans-serif;
    font-weight: 700;
    font-size: 14px;
    color: rgb(59, 59, 59);
}

.calendar-container-style {
    padding: 0px !important;
}



.error-message-style {
    font-family: "Roboto", sans-serif;
    color: red;
    font-weight: 400;
    font-size: 12px;
}
</style>
